import React from "react";
import {Route, Routes} from "react-router-dom";
import {ContactUsView} from "./views/ContactUsView";
import {SimpleContainer} from "./components/containers/SimpleContainer";

export const AppRoutes = () => (
    <Routes>
        <Route path="*" element={
            <SimpleContainer>
                <Routes>
                    <Route path="/*" element={<ContactUsView />} />
                </Routes>
            </SimpleContainer>
        } />
    </Routes>
);
